import React from 'react';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './BlogPost.scss';

// dynamically pull in every post module
const req = require.context(
  '../BlogPostsContent',
  false,
  /\.jsx?$/
);

const posts = req
  .keys()
  .map((key) => req(key).default)
  .filter((post) => post && post.id);

const BlogPost = () => {
  const { blogId } = useParams();
  const blog = posts.find((post) => post.id.toString() === blogId);

  if (!blog) return <div>Blog post not found.</div>;
  const canonicalUrl = `https://www.kleanleaf.us/blogs/${blog.id}`;
  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: blog.title,
    description: blog.metaTags.description,
    datePublished: blog.date,
    author: {
      "@type": "Organization",
      name: blog.metaTags.author || "Klean Leaf",
    },
    publisher: {
      "@type": "Organization",
      name: "Klean Leaf",
    },
    mainEntityOfPage: canonicalUrl,
  };

  return (
    <article className="blog-post-container">
      <Helmet>
        <title>{blog.title}</title>
        <meta name="description" content={blog.metaTags.description} />
        <meta name="keywords" content={blog.metaTags.keywords} />
        <meta name="author" content={blog.metaTags.author} />
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={blog.metaTags.description} />
        <meta property="og:image" content={blog.imageUrl1} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="article" />
        <link rel="canonical" href={canonicalUrl} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.title} />
        <meta name="twitter:description" content={blog.metaTags.description} />
        <meta name="twitter:image" content={blog.imageUrl1} />
        <script type="application/ld+json">{JSON.stringify(articleSchema)}</script>
      </Helmet>

      <header className="blog-post-header">
        <h1 className="blog-post-title">{blog.title}</h1>
        <p className="blog-post-date">{blog.date}</p>
      </header>

      <section className="blog-post-content">
        <img
          src={blog.imageUrl1}
          alt={blog.title}
          className="blog-post-image"
        />
        <div
          className="blog-text-content"
          dangerouslySetInnerHTML={{ __html: blog.content }}
        />
      </section>
    </article>
  );
};

export default BlogPost;
